import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fw-bold text-gray-600" }
const _hoisted_9 = { class: "odd" }
const _hoisted_10 = {
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_11 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_16 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_21 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([[_ctx.loading && 'overlay overlay-block'], "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"]),
        id: "kt_customers_table",
        role: "grid"
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (cell.key == 'checkbox')
                  ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll())),
                          name: "headCheckbox",
                          checked: _ctx.$props.checked
                        }, null, 8, _hoisted_6)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("th", {
                      key: 1,
                      onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                      class: _normalizeClass([
                  cell.name && 'min-w-125px',
                  cell.sortable !== false && 'sorting',
                  _ctx.tableHeader.length - 1 === i,
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ]),
                      tabindex: "0",
                      rowspan: "1",
                      colspan: "1",
                      style: {"cursor":"pointer"}
                    }, _toDisplayString(cell.name), 11, _hoisted_7))
              ], 64))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_8, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "odd"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: i,
                      class: _normalizeClass({ 'text-left': _ctx.tableHeader.length - 1 === i })
                    }, [
                      _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                        _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                      ])
                    ], 2))
                  }), 128))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            _createElementVNode("tr", _hoisted_9, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.emptyTableText), 1)
            ])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("label", null, [
                _createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                }, _hoisted_21, 32)
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "info-footer")
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.page) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}